import { ContentChild, Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[my-lead-list-header]'
})
export class MyLeadListHeader {
  constructor(public templateRef: TemplateRef<Element>) {}
}

@Directive({
  selector: '[my-lead-list-title]'
})
export class MyLeadListTitle {
  constructor(public templateRef?: TemplateRef<Element>) {}
}

@Directive({
  selector: '[my-lead-list-content]'
})
export class MyLeadListContent {
  constructor(public templateRef: TemplateRef<Element>) {}
}

@Directive({
  selector: '[my-lead-list-footer]'
})
export class MyLeadListFooter {
  constructor(public templateRef: TemplateRef<Element>) {}
}

@Directive({
  selector: 'my-lead-list'
})
export class MyLeadList {
  @Input() header = '';
  @Input() headerIcon = '';
  @Input() itemsCount = 0;

  @ContentChild(MyLeadListTitle) customTitle?: MyLeadListTitle;
  @ContentChild(MyLeadListHeader) customHeader?: MyLeadListHeader;
  @ContentChild(MyLeadListContent) content?: MyLeadListContent;
  @ContentChild(MyLeadListFooter) footer?: MyLeadListFooter;

  constructor() {}
}

@Directive({
  selector: '[my-lead-list-sidebar-content]'
})
export class SidebarContent {
  constructor(public templateRef: TemplateRef<Element>) {}
}

@Directive({
  selector: 'my-lead-list-sidebar'
})
export class MyLeadListSidebar {
  @Input() sidebarIcon = 'filter';

  @ContentChild(SidebarContent) content?: SidebarContent;

  constructor() {}
}

export const MyLeadListLayoutElements = [MyLeadListSidebar, MyLeadList, SidebarContent, MyLeadListFooter, MyLeadListContent, MyLeadListTitle, MyLeadListHeader];
